export var VERSION = '2.3.8';
//# sourceMappingURL=version.js.map